import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ReviewResponseService = /** @class */ (function () {
    function ReviewResponseService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    /**
     * updates specified contact in api server
     * @param {number} entityId
     * @param {boolean} isAirport
     * @param {number} reviewId
     * @param {string} response
     * @return {Promise<any>}
     */
    ReviewResponseService.prototype.putReviewResponse = function (entityId, isAirport, reviewId, response) {
        try {
            var URL_1 = '';
            if (response.length < 1) {
                response = null;
            }
            if (isAirport) {
                URL_1 = environment.airportsApiUrl + "/airports/" + entityId + "/review/" + reviewId + "/response";
            }
            else {
                URL_1 = environment.airportsApiUrl + "/businesses/" + entityId + "/review/" + reviewId + "/response";
            }
            var BODY = this._getResponseJSON(response);
            return this._http.put(URL_1, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * converts business contact to json obj
     * @param {string} response
     * @return {any}
     * @private
     */
    ReviewResponseService.prototype._getResponseJSON = function (response) {
        return {
            response: response
        };
    };
    ReviewResponseService.ngInjectableDef = i0.defineInjectable({ factory: function ReviewResponseService_Factory() { return new ReviewResponseService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: ReviewResponseService, providedIn: "root" });
    return ReviewResponseService;
}());
export { ReviewResponseService };
